<div class="select">
  <div
    class="select-input"
    [ngClass]="{
      'select-input-opened': optionsVisible,
      'no-border': noBorder,
      disabled: disabled,
    }"
    (click)="inputOnClick()"
  >
    @if (selectedIndex !== -1) {
      <div class="select-input-value">
        @if (options[selectedIndex].iconPath) {
          <img [src]="options[selectedIndex].iconPath" class="option-img" />
        }
        <div class="select-input-value-text" appLongTextTooltip>
          {{
            useLabelProviderPipe
              ? (options[selectedIndex].displayName | labelsProvider)
              : useBeutifyStringProviderPipe
                ? (options[selectedIndex].displayName | beautifyDisplayString)
                : options[selectedIndex].displayName
          }}
        </div>
      </div>
    } @else {
      <div class="select-input-placeholder">
        {{ placeHolder }}
      </div>
    }
    <img src="assets/images/arrows/empty-arrow-down.svg" class="drop-down" alt="expand" />
  </div>
  @if (optionsVisible) {
    <div class="select-options" (clickOutside)="optionsVisible = false" [delayClickOutsideInit]="true">
      @for (option of options; track i; let i = $index) {
        <div
          class="select-option"
          [ngClass]="{
            'select-option-selected': selectedIndex === i,
            'select-option-disabled': option.disabled,
          }"
          (click)="onSelect(i); $event.stopPropagation()"
          [matTooltip]="option.tooltip ? option.tooltip : ''"
          matTooltipPosition="left"
          matTooltipClass="tooltip-container"
        >
          @if (option.iconPath) {
            <img [src]="option.iconPath" class="option-img" />
          }
          <div class="option-text" appLongTextTooltip>
            {{
              useLabelProviderPipe
                ? (option.displayName | labelsProvider)
                : useBeutifyStringProviderPipe
                  ? (option.displayName | beautifyDisplayString)
                  : option.displayName
            }}
          </div>
        </div>
      }
    </div>
  }
</div>
